import clsx from "clsx";
import { memo, useMemo } from "react";
import { useTranslation } from "react-i18next";

import { Icon } from "@atoms/icon";
import { Typography } from "@atoms/typography";
import { Tooltip } from "@molecules/tooltip";
import { usePageMode } from "@stores/uiStore";

import classes from "./styles.module.scss";

import type { ILabelProps } from "./types";

export const Label = memo(function Label(props: ILabelProps) {
  const {
    isRequired,
    labelSize = "medium",
    text,
    hintText,
    children,
    className,
    noTitle,
    forceMode,
    noRequiredOrOptional,
    action,
    ...rest
  } = props;

  const pageMode = usePageMode();
  const mode = forceMode || pageMode;
  const isDisplayBadge = useMemo(
    () => mode === "create" || mode === "index",
    [mode],
  );

  const { t } = useTranslation("component");

  return (
    <>
      {!noTitle && (
        <label className={clsx(className, classes.container)} {...rest}>
          <div className={clsx(classes.label)}>
            <Typography
              fontType={
                labelSize === "medium" ? "label-small" : "paragraph-small"
              }
              themeColor={"text-strong-900"}
            >
              {text}
            </Typography>
            {isRequired && isDisplayBadge && !noRequiredOrOptional && (
              <Typography
                fontType={"label-small"}
                className={clsx(classes.isRequired)}
              >
                {"*\r"}
              </Typography>
            )}
            {!isRequired && isDisplayBadge && !noRequiredOrOptional && (
              <Typography
                fontType={"paragraph-small"}
                themeColor={"text-sub-600"}
              >
                {`(${t("label.optional")})`}
              </Typography>
            )}
            {hintText && (
              <Tooltip title={hintText}>
                <div className={"icon-wrapper"}>
                  <Icon
                    fontSize={"fs-16"}
                    color={"icon-disabled-300"}
                    name={"InformationFill"}
                  />
                </div>
              </Tooltip>
            )}
          </div>

          {action}
        </label>
      )}
      {children}
    </>
  );
});
